import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/gantt/gantt';
import Visualizar from './Visualizar';


const ms2p = (state) => {
  return {
    ...state.gantt,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Visualizar);